export default __webpack_public_path__ + "static/media/B14.55ee5ab7.png";